/** Runs before instrumentation, analytics and the router. Clerk callback
 * parameters are deliberately untouched: only our portal routes consume these. */
const memory = new Map<string, string>();

export function consumePortalCredentials(win: Window = window): void {
  const match = /^\/portal\/([^/]+)(?:\/|$)/.exec(win.location.pathname);
  if (!match) return;
  const slug = decodeURIComponent(match[1]);
  const url = new URL(win.location.href);
  let changed = false;
  for (const key of ['token', 'email']) {
    const value = url.searchParams.get(key);
    if (value !== null) {
      const storageKey = `bill-alps-portal-${key}:${slug}`;
      memory.set(storageKey, value);
      try {
        win.localStorage.setItem(storageKey, value);
      } catch {
        /* private browsing */
      }
      url.searchParams.delete(key);
      changed = true;
    }
  }
  if (changed)
    win.history.replaceState(
      win.history.state,
      '',
      url.pathname + url.search + url.hash,
    );
}

export function readPortalCredential(storageKey: string): string | null {
  try {
    return localStorage.getItem(storageKey) ?? memory.get(storageKey) ?? null;
  } catch {
    return memory.get(storageKey) ?? null;
  }
}

if (typeof window !== 'undefined') consumePortalCredentials();
